import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CoursesService } from './api/courses.service';
import { GroupsService } from './api/groups.service';
import { ImportsService } from './api/imports.service';
import { LeaderboardsService } from './api/leaderboards.service';
import { MobileService } from './api/mobile.service';
import { NotificationsService } from './api/notifications.service';
import { PairingsService } from './api/pairings.service';
import { PlayerTypeLinksService } from './api/playerTypeLinks.service';
import { PlayersService } from './api/players.service';
import { PlayoffsService } from './api/playoffs.service';
import { PointsRacesService } from './api/pointsRaces.service';
import { PursesService } from './api/purses.service';
import { ReferenceService } from './api/reference.service';
import { ReportsService } from './api/reports.service';
import { ScorecardsService } from './api/scorecards.service';
import { SystemInfoService } from './api/systemInfo.service';
import { TeamsService } from './api/teams.service';
import { TournamentsService } from './api/tournaments.service';
import { ToursService } from './api/tours.service';
import { WebhooksService } from './api/webhooks.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CoursesService,
    GroupsService,
    ImportsService,
    LeaderboardsService,
    MobileService,
    NotificationsService,
    PairingsService,
    PlayerTypeLinksService,
    PlayersService,
    PlayoffsService,
    PointsRacesService,
    PursesService,
    ReferenceService,
    ReportsService,
    ScorecardsService,
    SystemInfoService,
    TeamsService,
    TournamentsService,
    ToursService,
    WebhooksService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
